import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <p>
      @2022{` `}
      <a
        href="https://github.com/Jane-Mar/weather-app-react"
        rel="noreferrer"
        target="_blank"
      >
        open-sourced
      </a>
      , by Jane Marinina      
    </p>
  );
}
